import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import QrScannerComponent from "../../components/shared/QrScannerComponent";
import { useNavigate } from "react-router-dom";
import ErrorCard from "../../components/shared/ErrorCard";

const ScanPage = () => {

    const navigate = useNavigate();

    const [qr, setQr] = useState("");
    const [errorMsg, setErrorMsg] = useState("");


    useEffect(() => {
        if (qr.length > 0) {
            let qr_code = qr.split('qr/')[1];
            localStorage.setItem('qr', qr_code);
            navigate('/hw/dashboard/anlagen/top/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qr]);

    return (
        <Container>
            {errorMsg.length > 1 ? 
                <ErrorCard error={errorMsg} />
            :null}
            <Row hidden={qr.length > 0}>
                <Col>
                    <QrScannerComponent setQr={setQr} setErr={setErrorMsg} />
                </Col>
            </Row>
        </Container>
    )
}
export default ScanPage;